<template>
  <div class="my-class">
    <div class="sign-in-box">
      <div style="display: flex; align-items: center;">
        <img :src="userImg !== 'null' && userImg ? userImg : require('../../assets/images/user_img.png')" style="width: 100px; height: 100px; border-radius: 50px; border: 6px solid #95C3FF; margin-right: 30px;" />
        <div style="font-size: 20px; color: #fff;">
          <div>班级：{{ className }}</div>
          <div style="font-size: 16px; margin-top: 10px;">姓名：{{ urerName }}</div>
        </div>
      </div>
      <div style="font-size: 20px; display: flex; color: #fff; align-items: center;">
        <div v-if="teacherData.course_name">
          {{ teacherData.t_name }}正在上<span style="color: #1968FF;">{{ teacherData.course_name }}</span
          >，快去签到学习吧！
        </div>
        <el-button type="primary" @click="signInNow" style="margin-left: 60px;" v-if="teacherData.course_name">签到上课</el-button>
      </div>
    </div>
    <div style="display: grid; grid-template-columns: repeat(3, 1fr); grid-gap: 24px; margin: 20px 16%;">
      <div style="position: relative;" @click="toPracticalList">
        <img src="../../assets/images/my-class-bg1.png" style="width: 100%; cursor: pointer;" />
        <div style="color: #6D1CFF; position: absolute; top: 50%; right: 24%;">
          <span style="font-size: 32px;">{{ shixun_num }}</span
          >次
        </div>
      </div>
      <div style="position: relative;" @click="toQuizList">
        <img src="../../assets/images/my-class-bg2.png" style="width: 100%; cursor: pointer;" />
        <div style="color: #FFA62F; position: absolute; top: 50%; right: 24%;">
          <span style="font-size: 32px;">{{ xiaoce_num }}</span
          >次
        </div>
      </div>
      <div style="position: relative;" @click="toDiscussList">
        <img src="../../assets/images/my-class-bg3.png" style="width: 100%; cursor: pointer;" />
        <div style="color: #006EFF; position: absolute; top: 50%; right: 24%;">
          <span style="font-size: 32px;">{{ taolun_num }}</span
          >次
        </div>
      </div>
    </div>
    <div style="flex:1; display: flex; margin: 0 16%;">
      <div class="content-box">
        <el-scrollbar style="height: calc(100vh - 495px); overflow-x: hidden;">
          <el-tabs v-model="activeName">
            <el-tab-pane label="课程内容" name="课程内容">
              <div class="course-item" v-for="(item, index) in myCourses">
                <img :src="item.course_cover" style="width: 167px; height: 100%; border-radius: 8px; margin-right: 20px;" />
                <div style="display: flex; flex-direction: column; justify-content: space-between;">
                  <div style="margin-bottom: 18px;">{{ item.course_name }}</div>
                  <el-progress :percentage="item.progress_rate" style="width: 600px;" :show-text="false" :stroke-width="8"></el-progress>
                  <div>
                    学习章节进度<span style="margin-left: 10px;">{{ item.finish_chapter_num }}/ {{ item.chapter_num }}章</span>
                  </div>
                </div>
              </div>
            </el-tab-pane>
            <el-tab-pane label="历史记录" name="历史记录">
              <el-table :data="signInData" style="width: 100%; flex: 1; margin-top: 30px; height: calc(100vh - 565px); overflow-y: auto;" stripe :header-cell-style="headStyle" :cell-style="cellStyle">
                <el-table-column prop="tran_start_time" label="日期"></el-table-column>
                <el-table-column prop="course_name" label="课程"> </el-table-column>
                <el-table-column prop="is_sign" label="签到状态">
                  <template slot-scope="scope">
                    <div v-if="scope.row.is_sign">已签到</div>
                    <div v-else style="color: #FF0000">未签到</div>
                  </template>
                </el-table-column>
                <el-table-column label="章节">
                  <template slot-scope="scope">
                    <span>{{ scope.row.chapter_sign }} / {{ scope.row.chapter_num }}</span>
                  </template>
                </el-table-column>
                <el-table-column prop="t_name" label="授课老师"></el-table-column>
              </el-table>
            </el-tab-pane>
          </el-tabs>
        </el-scrollbar>
      </div>
      <div class="student-box">
        <el-scrollbar>
          <div style="padding: 0 20px 20px 20px; border-bottom: 1px solid #EEE;">班级成员</div>
          <div class="student-item" v-for="(stu, index) in stuList" @click="viewStudentDetail(stu)">
            <!-- <img :src="stu.s_ico ? stu.s_ico : require('../../assets/images/user_img.png')" style="width: 40px; height: 40px; border-radius: 20px;" />
            <div style="color: #000; margin-left: 10px;">{{ stu.s_name }}</div> -->
            <div class="avavtor">
              <img :src="stu.s_ico ? stu.s_ico : require('../../assets/images/user_img.png')" /> 
              <div class="circle" :class="stu.sex=='女'?'girl_circle':'boy_circle'">
                <i class="iconfont" v-if="stu.sex=='女'">&#xe8b4;</i>
                <i class="iconfont" v-else>&#xe8b3;</i>
              </div> 
            </div>
            <div class="info">
              <div class="top"><span class="name">{{ stu.s_name }}</span><span class="account">({{  stu.s_account}})</span></div>
              <div class="bottom">{{ stu.create_time }}</div>
            </div>
          </div>
        </el-scrollbar>
      </div>
    </div>
  </div>
</template>

<script>
// import Swiper from 'swiper';
import { Swiper, SwiperSlide, directive } from "vue-awesome-swiper";
import "swiper/css/swiper.css";
import {wssUrl} from "../../config/wss";
import { sendWsData } from "@/utils/utils";

export default {
  name: "Myclass",
  data() {
    return {
      userImg: localStorage.getItem("sIcon"),
      urerName: localStorage.getItem("sUsername"),
      activeName: "课程内容",
      classId: Number(localStorage.getItem("c_id")) || "",
      className: "",
      stuList: [],
      shixun_num: "",
      xiaoce_num: "",
      taolun_num: "",
      myCourses: [],
      signInData: [],
      chapter_sign: 0,
      node_sign:0,
      teacherData: {
        course_id: 0,
        course_name: "",
        t_name: "",
      },
      courseSwiperOption: {
        autoplay: false,
        slidesPerView: 4,
        spaceBetween: 16,
        // loop: true,
        navigation: {
          nextEl: ".banner-swiper-btn-next",
          prevEl: ".banner-swiper-btn-prev",
        },
        observer: true,
        observeParents: true,
      },
      course_id: "",
      course_record_id: "",
      t_course_id: "",
      ws: null,
      wsTimer: null,
    };
  },
  components: {
    Swiper,
    SwiperSlide,
  },
  directives: {
    swiper: directive,
  },
  created() {
    this.getStudentList();
    this.getStatistics();
    this.getCourseHistoryList();
    this.getTeacherCourseByClass();
    this.getCourseProgressList();
  },
  mounted() {
    this.wsInit();
  },
  beforeDestroy() {
    if (this.wsTimer) clearInterval(this.wsTimer);
  },
  methods: {
    headStyle() {
      return "background: #FAFAFA; fontWeight: 500; font-family: PingFang SC, PingFang SC; padding-left: 24px; color:#3E3E3E; height: 42px;";
    },
    cellStyle() {
      return "padding-left: 24px; height: 60px; color: #333;";
    },
    wsInit() {
      
      this.ws = new WebSocket(wssUrl());
      this.ws.onopen = () => {
        console.log("连接成功",wssUrl());
        if (this.wsTimer) clearInterval(this.wsTimer);
        this.wsTimer = setInterval(() => {
         const sendMsg = sendWsData("ping");
          this.ws.send(sendMsg);
        }, 50000);
        this.ws.send(sendWsData("bind"));
      };
      this.ws.onmessage = (evt) => {
        const data = evt.data;
        try {
          const result = JSON.parse(data);                             
          console.log("result-student", result);
          console.log(" this.course_record_id", this.course_record_id,);
          
          //教师上课的通知
          if (result.code === 200 && result.data.type === "notice") {
            this.teacherData.course_name = result.data.course_name;
            this.teacherData.t_name = result.data.t_name;
            this.teacherData.course_id = result.data.course_id;
            this.course_record_id = result.data.course_record_id;
            console.log(result.data,"result.data");
            
            this.t_course_id = result.data.course_id;
            this.getTeacherCourseByClass();
          }
          if (result.code === 204) {
            this.$router.push("/");
          }
          //教师结束上课的通知
          if (result.code === 200 && result.data.type === "end_notice") {
            this.getTeacherCourseByClass();
          }
        } catch (e) {
          console.log("返回数据格式异常：", e);
        }
      };

      this.ws.onclose = () => {
        console.log("断开连接");
        this.wsInit();
      };
    },
    //绑定客户端
    bindClient(client_id) {
      this.$shttp.axiosGetBy(
        this.$api.bindClient,
        { clientID: client_id },
        (res) => {
          console.log(res);
        },
        (err) => {
          console.log(err);
        }
      );
    },
    signInNow() {
      console.log("teacher_data", this.teacherData);
      this.$store.dispatch("setRefreshVal", 0);
      this.$shttp.axiosPost(this.$api.stuSignIn, { course_record_id: this.course_record_id }, (res) => {
        if (res.code === 200) {
          this.$message({
            type: "success",
            message: "签到成功！",
            duration: 1000,
            onClose: () => {
              this.$router.push({
                path: "/course/inclass",
                query: {
                  id: this.t_course_id,
                  className: this.className,
                  classId: Number(localStorage.getItem("c_id")),
                  recordId: this.course_record_id,
                  tCourseId: this.t_course_id,
                  chapter: this.chapter_sign,
                  node: this.node_sign,
                },
              });
              // let routeUrl = this.$router.resolve({
              //     path: '/course/courseIndex',
              //     query: {
              //         id: this.teacherData.student_course_id,
              //         className: this.className,
              //         classId: Number(localStorage.getItem('c_id')),
              //         recordId: this.course_record_id,
              //         tCourseId: this.t_course_id,
              //     }
              // });
              // window.open(routeUrl .href, '_blank');
            },
          });
        } else {
          this.$message({
            type: "success",
            message: res.msg,
            duration: 1000,
            onClose: () => {
              this.$router.push({
                path: "/course/inclass",
                query: {
                  id: this.teacherData.student_course_id,
                  className: this.className,
                  classId: Number(localStorage.getItem("c_id")),
                  recordId: this.course_record_id,
                  tCourseId: this.t_course_id,
                  chapter: this.chapter_sign,
                  node: this.node_sign,
                },
              });
              // let routeUrl = this.$router.resolve({
              //     path: '/course/courseIndex',
              //     query: {
              //         id: this.teacherData.student_course_id,
              //         className: this.className,
              //         classId: Number(localStorage.getItem('c_id')),
              //         recordId: this.course_record_id,
              //         tCourseId: this.t_course_id,
              //     }
              // });
              // window.open(routeUrl .href, '_blank');
            },
          });
        }
      });
      // return
    },
    getStudentList() {
      this.$shttp.axiosGetBy(
        this.$api.showStudent,
        { type: "all", c_id: Number(localStorage.getItem("c_id")) },
        (res) => {
          if (res.code === 200) {
            this.stuList = res.data;
            this.className = res.data[0].c_name;
          }
        },
        (err) => {
          console.log(err);
        }
      );
    },
    getStatistics() {
      let params = {
        c_id: Number(localStorage.getItem("c_id")),
      };
      this.$shttp.axiosGetBy(
        this.$api.statistics,
        params,
        (res) => {
          if (res.code === 200) {
            this.shixun_num = res.data.sx_num;
            this.xiaoce_num = res.data.xc_num;
            this.taolun_num = res.data.tl_num;
          }
        },
        (err) => {
          console.log(err);
        }
      );
    },
    //学生查询教师在某个班级下的开课情况
    getTeacherCourseByClass() {
      this.$shttp.axiosGet(this.$api.getTeacherCourseByClass, (res) => {
        if (res.code === 200) {
          this.teacherData = res.data;
          console.log("||", this.teacherData);
          this.course_id = res.data.student_course_id;
          this.chapter_sign = res.data.chapter_sign;
          this.course_record_id = res.data.course_record_id;
          this.t_course_id = res.data.course_id;
          this.node_sign=res.data.node
        }
      });
    },
    getCourseProgressList() {
      let params = {
        c_id: Number(localStorage.getItem("c_id")),
        course_id: this.course_id,
      };
      this.$shttp.axiosGetBy(this.$api.getCourseProgressList, params, (res) => {
        if (res.code === 200) {
          this.myCourses = res.data.data1;
        }
      });
    },
    getCourseHistoryList() {
      let params = {
        c_id: Number(localStorage.getItem("c_id")),
        course_id: this.course_id,
      };
      this.$shttp.axiosGetBy(this.$api.getCourseProgressList, params, (res) => {
        if (res.code === 200) {
          this.signInData = res.data.data2.data;
        }
      });
    },
    toPracticalList() {
      this.$router.push({
        path: "/teacherClass/practicalList",
        query: {
          classId: Number(localStorage.getItem("c_id")),
          className: this.className,
        },
      });
    },
    toQuizList() {
      this.$router.push({
        path: "/teacherClass/studentQuizList",
        query: {
          classId: Number(localStorage.getItem("c_id")),
          className: this.className,
        },
      });
    },
    toDiscussList() {
      this.$router.push({
        path: "/teacherClass/discussList",
        query: {
          classId: Number(localStorage.getItem("c_id")),
          className: this.className,
        },
      });
    },
    goBack() {
      this.$router.go(-1);
    },
    //查看学生
    viewStudentDetail(item) {
      console.log("item", item);
      this.$router.push({
        path: "/teacherClass/student/detail",
        query: {
          sId: item.s_id,
        },
      });
    },
  },
};
</script>

<style lang="scss" scoped>
* {
  box-sizing: border-box;
}
.my-class {
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  ::v-deep .el-tabs__header {
    margin: 0;
  }
  ::v-deep .el-table::before {
    height: 0;
  }
  .sign-in-box {
    background: url(../../assets/images/student-class-bg.png);
    height: 200px;
    padding: 0 16%;
    display: flex;
    justify-content: space-between;
    align-items: center;
  }
  .content-box {
    flex: 1;
    margin: 0 24px 20px 0;
    background: #fff;
    padding: 20px 30px 30px 30px;
    ::v-deep .el-tabs__item.is-active {
      color: #006eff;
    }
    ::v-deep .el-tabs__active-bar {
      background-color: #006eff;
    }
    ::v-deep .el-scrollbar__wrap {
      overflow: auto;
    }
  }
  .course-item {
    width: 100%;
    height: 156px;
    padding: 30px;
    margin-top: 30px;
    background: #f2f6fa;
    border: 1px solid #eee;
    border-radius: 10px;
    display: flex;
  }
  .student-box {
    width: 240px;
    padding: 20px 0;
    background: #fff;
    margin-bottom: 20px;
  }
  .student-item {
    height: 60px;
    border-bottom: 1px solid #eee;
    padding: 0 10px;
    display: flex;
    align-items: center;
    cursor: pointer;
    .avavtor{
      width: 40px;
      height: 40px; 
      border-radius: 100%;
      position: relative;
      img{
        width: 100%;
        height: 100%;
        border-radius: 100%;
        object-fit: cover;
      }
      .circle{
        position: absolute;
        width: 18px;
        height: 18px;
        bottom: 0px;
        right: 2px;
        // background: skyblue;
        border-radius: 100%;
        display: flex;
        align-items: center;
        justify-content: center;
        font-size: 11px;
      }
      .girl_circle{
        color: #FF6969 ;
        background: #ffd6d6;

      }
      .boy_circle{
        color: #006FFF ;
        background: #daeaff;
      }
    }
    .info{
      margin-left: 10px;
      .top{
          .name{
          font-family: PingFang SC, PingFang SC;
          font-weight: 500;
          font-size: 14px;
          color: #000000;
          line-height: 16px;
          text-align: left;
          font-style: normal;
          text-transform: none;
        }
        .account{
          font-family: PingFang SC, PingFang SC;
          font-weight: 500;
          font-size: 14px;
          color: #999999;
          line-height: 16px;
          text-align: left;
          font-style: normal;
          text-transform: none;
          margin-left: 3px;
        }
      }
      .bottom{
        margin-top: 5px;
        font-family: PingFang SC, PingFang SC;
        font-weight: 400;
        font-size: 12px;
        color: #999999;
        line-height: 14px;
        text-align: left;
        font-style: normal;
        text-transform: none;
      }
    }
  }
}
</style>
